// "rawFile" is assumed to be an object of type "File"
const processRawFile = rawFile => new Promise((resolve, reject) => {
  // the wrapper here is to make it easier to mock for testing purposes

  const reader = new FileReader();
  reader.onabort = error => {
    /* eslint-disable-next-line no-console */
    console.log('file reading was aborted');
    reject(error);
  };
  reader.onerror = error => {
    /* eslint-disable-next-line no-console */
    console.log('file reading has failed');
    reject(error);
  };
  reader.onload = e => {
    resolve(new Uint8Array(e.target.result));
  };
  reader.readAsArrayBuffer(rawFile);
});
export default {
  processRawFile
};